function enableResponses(noTimeout) {
	console.log('enableResponses');

	var isButtons = trialHasButtonsActive(window.trialRow);
	var isKeyboard = columnForTrial('keyboard', window.trialRow) != 'na';
	var isCustomType = columnForTrial('responseType', window.trialRow) != 'na';
	var isDefaultResponseType = !isButtons && !isKeyboard && !isCustomType;

	if (isDefaultResponseType) {
		//current screen
		var hasMultipleStimuli = trialHasMultipleStimuliOnAnyScreenStartingWith(window.listTrialScreensTimings, window.trialRow, window.currentScreenIndex -1);

		if (hasMultipleStimuli) {
			//clicks
			enableClickResponse();
		} else {
			enableInputBoxResponse();
		}
	} else {
		if (isKeyboard && canActivateKeyboardInputType()) {
			enableKeyResponse();
		}

		//specific response type
		if (isCustomType) {
			showResponseOptions();
		}

		if (isButtons) {
			showButtons();
			if(columnForTrial('responseType', trialRow) == "clicks"){
				enableClickSelection(trialRow);
			}
		}
	}

	//set start of RT measurement here as from now on the user can respond to the trial
	window.timeInMs = performance.now();

	return;

	function enableKeyResponse() {
		window.recordKeys = 1;
		enableMinimumResponseWindowKeys();
	}

	function enableInputBoxResponse() {
		setResponseTopPosition();//compute where we should display the buttons
		var minimumTop = window.getMinimumTopPosition();
		var inputTop = currentButtonTop > minimumTop ? currentButtonTop : minimumTop;
		buttonsContainers[0].style.top = inputTop + "px";
		buttonsContainers[0].style.left = (canvasWidth/2 - $('#responseBox').width()/2) + "px";
		showResponseBox();
	}

	function canActivateKeyboardInputType() {
		var responseType = columnForTrial('responseType', window.trialRow);
		var incompatibleValues = ['slider', 'box', 'comment'];
		return incompatibleValues.indexOf(responseType) == -1;
	}
}

function enableClickResponse() {
	var className = 'clickableImage';
	if (hasClicksOptions()) {
		className += ' clicksOptions';
	}

	if (isLongWordTrial(window.trialRow)){
		className += ' longword';
	}
	
	else if(isTrialOfType(trialRow, 'word')){
		className += ' word';
	}

	for (var i = 1; i <= window.stimFieldsMax; i++) {
		$(stimContainers[i]).off('click');
		$(stimContainers[i]).on('click', (function(il) {
			return function(e) {
				clickStim(e, this, il);
			};
		})(i));
		window.stimContainers[i].className = className;
	}

	if (hasMultipleClicks()){
		enableMultipleClicksSelection(window.trialRow);
	}

	enableMinimumResponseWindowClicks();
}

function trialHasButtonsActive(trialRow) {
	return columnForTrial('button1', trialRow) != 'na'; //at least the first button is defined
}

function trialHasClicksEnabled(trialRow) {
	return $('#image1.clickableImage:visible').length > 0 || $('#word1.clickableImage:visible').length > 0;
}

function disableResponses(){
	if(trialHasClicksEnabled()){
		for (var i = 1; i <= window.stimFieldsMax; i++){
			disableWordClicks(i);
		}
	}

	window.hideResponses();
}

function enableMinimumResponseWindowKeys() {
	window.enableResponseWindowAfterMinimumDuration(function(){
		window.minimumResponseWindowEnded = false;
		window.lastKey = null;
		window.lastRTTimestamp = null; 
	}, function(){
		window.minimumResponseWindowEnded = true;
		if(window.lastKey !== null){
			nextTrialWithKeys(window.lastKey, null, window.lastRTTimestamp);
		}
	});
}

function enableMinimumResponseWindowClicks() {
	window.enableResponseWindowAfterMinimumDuration(function(){
		window.minimumResponseWindowEnded = false;
		window.lastClick = null;
		window.lastRTTimestamp = null;
	}, function(){
		window.minimumResponseWindowEnded = true;
		if(window.lastClick !== null){
			clickGeneral(window.lastClick, null, window.lastRTTimestamp);
		}
	});
}